import { useContext, useState } from 'react';
import { Buttons, FlexContainer, ModalContext, Modals, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import EventService from 'Services/events';
import { useTranslation } from 'Hooks/useTranslation';
import { BodyObject } from 'Containers/Plans/components/CardPlan/types';
import { useFetchCheckout } from 'Containers/Plans/hooks';
import { createURL } from 'Containers/Plans/utils';
import { useCreateDomiciliation } from 'Containers/Dashboard/components/TaxScreen/components/DomiciliationBanner/hooks';
import { routes } from 'Constants/routes';
import * as Styled from './styles';

export const DomiciliationType = (): JSX.Element => {
  const [type, setType] = useState<'bank' | 'card'>();
  const { mutate: createDomiciliation } = useCreateDomiciliation();
  const { mutate } = useFetchCheckout();
  const { hideModal } = useContext(ModalContext);
  const { t } = useTranslation(locizeNS.MODALS);
  const stripeActionUrl = createURL(routes.DASHBOARD);
  const handleClick = (): void => {
    if (type === 'card') {
      const body: BodyObject = {
        checkoutConfig: {
          successUrl: stripeActionUrl,
          cancelUrl: stripeActionUrl,
          paymentMethod: 'card',
        },
        type: 'setup',
      };
      EventService.saveCardSessionStarted();
      mutate(body);
    } else {
      createDomiciliation({});
    }
  };

  return (
    <Modals.Centered maxSize="M" hasClose onClose={hideModal}>
      <FlexContainer direction="column" gap="dimension_16" fullWidth>
        <Text color="dark" type="headline" size="XS_L_S" align="center">
          {t('DomiciliationType.Title')}
        </Text>
        <Text color="fresh" type="paragraphs" size="M_L_S" align="center">
          {t('DomiciliationType.Subtitle')}
        </Text>
        <Styled.TypeCell
          hasArrow={false}
          size="M"
          onClick={() => setType('bank')}
          isSelected={type === 'bank'}
          checked={type === 'bank'}
        >
          <Text type="paragraphs" size="M_L_S" color="dark">
            {t('DomiciliationType.bank.label')}
          </Text>
        </Styled.TypeCell>
        <Styled.TypeCell
          hasArrow={false}
          size="M"
          onClick={() => setType('card')}
          isSelected={type === 'card'}
          checked={type === 'card'}
        >
          <Text type="paragraphs" size="M_L_S" color="dark">
            {t('DomiciliationType.card.label')}
          </Text>
        </Styled.TypeCell>
        <Text type="paragraphs" size="XS_M_S" color="grey" align="center">
          {t('DomiciliationType.info')}
        </Text>
        <FlexContainer fullWidth justify="center" align="center">
          <Buttons.Classic
            mode="primary"
            size="m"
            onClick={handleClick}
            label={t('DomiciliationType.button')}
          />
        </FlexContainer>
      </FlexContainer>
    </Modals.Centered>
  );
};
